import {LobbyImage} from '@colonist/types'
import {createDivIn} from '../../../ui_utils/DomUtils'
import {UIGameHelpButtonsController} from '../UIGameHelpButtonsController'
import {UIGameInformationView} from './UIGameInfomationView'
import {UIGameHelpButton} from '../UIGameHelpButton'

export class UIGameInformationButton extends UIGameHelpButton {
    private readonly informationView: UIGameInformationView

    constructor(uiGameHelpButtonController: UIGameHelpButtonsController, parent: HTMLDivElement) {
        super(uiGameHelpButtonController, parent, 'in-game-information-button', LobbyImage.InfoIcon)

        const pointerContainer = createDivIn(this.gameHelpButtonContainer, 'info-box-pointer-container')
        createDivIn(pointerContainer, 'info-box-pointer')

        this.informationView = new UIGameInformationView(this.gameHelpButtonContainer, this.uiGameManager)
    }

    setContainerActive(visible: boolean): void {
        if(this.active === visible) return

        this.active = visible
        this.gameHelpButtonContainer.classList.toggle('card-closed')
    }

    overrideContentForBeginnerMode(actionIndex: number) {
        this.informationView.overrideContentForBeginnerMode(actionIndex)
    }
}
